import { enUS } from "date-fns/locale";
import { AllieDateRangePickerProps } from './DateRangePicker.types';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { StyledDateRangePicker } from './DateRangePicker.styles';

export const AllieDateRangePicker: React.FC<AllieDateRangePickerProps> = ({
  locale = enUS,
  ...props
}) => {
  return <StyledDateRangePicker locale={locale} {...props} />;
};
